import React from 'react';
import { useParams } from 'react-router-dom';
import { ProjectType, SetupAreaIdContext } from 'nekst-api';
import { TeamSetupAreaContext } from '../TeamSetupAreaContext';
import { ProjectDetailsFieldsList } from '../../projectdetails/List/ProjectDetailsFieldsList';
import { MarketPageBreadcrumbs } from '../MarketPageBreadcrumbs';
import { TeamSetupAreaInnerBlock } from '../TeamSetupAreaInnerBlock';
import CustomProcessActionsButton from './CustomProcessActionsButton';

export function CustomProcessDetailFieldsPage() {

  const {
    setupAreaId: setupAreaIdString,
  } = useParams<{
    setupAreaId: string,
  }>();

  const setupAreaId = setupAreaIdString ?? '';

  return (
    <SetupAreaIdContext data={{
      setupAreaId
    }}>
      <TeamSetupAreaContext>
        <MarketPageBreadcrumbs />

        <TeamSetupAreaInnerBlock
          projectType={ProjectType.LISTING}
          headerRight={<CustomProcessActionsButton />}
        >
          <ProjectDetailsFieldsList
            projectType={ProjectType.LISTING} />

        </TeamSetupAreaInnerBlock>
      </TeamSetupAreaContext>
    </SetupAreaIdContext>

  );
}
